module.exports = __webpack_public_path__ + "static/media/main_skybox_UP.280ae15a.png";